import {
  EXTENDED_WAITING_COPY,
  getBaseFreeWaitingMinutes,
  getExtendedWaitingUnitPrice,
} from "../utils/extendedWaiting";

export default function ExtendedWaitingSelector({
  language = "zh",
  pickupArea,
  quantity = 0,
  vehicleType,
  onChange,
  compact = false,
}) {
  const copy = EXTENDED_WAITING_COPY[language] || EXTENDED_WAITING_COPY.zh;
  const baseMinutes = getBaseFreeWaitingMinutes(pickupArea);
  const unitPrice = getExtendedWaitingUnitPrice(vehicleType);
  const addedMinutes = Number(quantity || 0) * 30;
  const amount = unitPrice * Number(quantity || 0);

  if (!unitPrice) return null;

  return (
    <div className={`${compact ? "mt-3" : "mt-6"} rounded-xl border border-primary/25 bg-primary/5 p-4`}>
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <label className="font-semibold text-foreground">{copy.title}</label>
        <span className="text-sm text-muted-foreground">¥{unitPrice.toLocaleString()} / 30 min</span>
      </div>
      <p className="mb-3 text-sm text-muted-foreground">{copy.included(baseMinutes)}</p>
      <select
        className="premium-input w-full"
        value={Number(quantity || 0)}
        onChange={(event) => onChange(Number(event.target.value))}
      >
        <option value={0}>{copy.none}</option>
        {[1, 2, 3, 4, 5, 6].map((blocks) => (
          <option key={blocks} value={blocks}>
            {copy.add(blocks * 30)} · ¥{(unitPrice * blocks).toLocaleString()}
          </option>
        ))}
      </select>
      {addedMinutes > 0 && (
        <div className="mt-3 rounded-lg bg-background/70 px-3 py-2 text-sm font-medium text-foreground">
          {copy.summary(addedMinutes, baseMinutes, baseMinutes + addedMinutes, amount)}
        </div>
      )}
    </div>
  );
}
